import { fork } from 'redux-saga/effects'

import { sagas as search } from './search'
import { sagas as companySearch } from './companySearch'
import { sagas as reportingBenchmark } from './reporting/benchmark'

import { sagas as dashboard } from './dashboard'
import { sagas as account } from './account'
import { sagas as system } from './system'
import { sagas as adminArea } from './adminArea'
import { sagas as pinger } from './pinger'

export default function* rootSaga() {
  yield fork(search)
  yield fork(companySearch)
  yield fork(reportingBenchmark)
  yield fork(dashboard)
  yield fork(account)
  yield fork(system)
  yield fork(adminArea)
  yield fork(pinger)
}
